<template>
  <div class="section section-details is-paddingless" v-if="commande">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailCommandeBailleur.title', { code: commande.code }) }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <div class="buttons">
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              v-if="isNotClosOrSansSuite && activeButtonEtLien"
              :permission="permCommandeAchat.maj"
              :actions="[]"
              @click="() => {
                $router.push({
                  name: 'm.baux.commande_achat-bailleur',
                  params: {id: $route.params.id}
                });
              }">
              {{ $t('detail.buttons.edit') }}&nbsp;
            </dropdownButton>
            <button class="button"
                    @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown
                  ref="dropdownEdition"
                  position="is-bottom-left"
                  class="has-text-left">
                  <div slot="trigger">
                    <b-icon
                      icon="chevron-down"
                      class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item
                    @click="checkPermissions(permCommandeAchat.editer)
                    ? edition({format: constantes.pdf,
                    typeDonnee: constantes.typeEditionCommande}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permCommandeAchat.editer)
                    ? edition({format: constantes.docx,
                    typeDonnee: constantes.typeEditionCommande}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permCommandeAchat.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <commande-detail
      :detailDevisCommande="commandeDetail"
      :devisCommande="commande">
    </commande-detail>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/commandeAchat/index';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import commandeDetail from '@/components/baux/commandeAchat/commandeDetail';
import { COMMANDE_ACHAT } from '@/configuration/baux/permissionsBauxConf';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import dropdownButton from '@/components/general/button/dropdownButton';
import * as devisConf from '@/configuration/devisConf';
import { TYPE_DOCX, TYPE_PDF } from '@/configuration/edition/editionConf';
import { TYPE_EDITION_CMD } from '@/configuration/commande/commandeConf';
import edition from '@/api/edition';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
export default {
  name: 'c_commandeAchat',
  components: {
    dropdownButton,
    breadcrumb,
    commandeDetail,
    pieceJointeButton,
  },
  data() {
    return {
      commandeDetail: null,
      commande: null,
      permCommandeAchat: COMMANDE_ACHAT,
      constantes: {
        pdf: TYPE_PDF,
        docx: TYPE_DOCX,
        typeEditionCommande: TYPE_EDITION_CMD,
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const response = await edition({
          ids: [this.commande.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationDevisCommande({ data: response },
            this.errorEdition.messages,
            null,
            devisConf.TYPE_COMMANDE);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide, translate);
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailCommandeBailleur.breadcrumb.listeCommandeBailleur'), route: { name: 'l.baux.commande_achat-bailleur' }, isActive: false },
        { title: this.$t('detailCommandeBailleur.breadcrumb.detailCommandeBailleur'), route: '', isActive: true },
      ];
    },
    isNotClosOrSansSuite() {
      return (this.commande.etat !== devisConf.ETAT_CLOTURER
        && this.commande.etat !== devisConf.ETAT_SANSSUITE);
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.commande.societeId);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Commande' });
      this.commande = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentElementId({ id: this.commande.id });
      const commandeDetail = detailDevisCommande(this.commande);
      this.commandeDetail = commandeDetail;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.commande.code }));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style scoped>

</style>
